<template>
  <div
    class="canvas-preview__content"
    ref="canvas-preview"
    v-if="slide.name"
  >
    <div
      class="vertical layout center center-justified content__text"
      v-if="slide.error"
    >
      <div class="content__text-icon" :class="{'has-icon-inside': slide.type === 'question'}">
        <aha-icon
          :name="slide.ahaIcon"
          :maintainColor="true"
          v-if="slide.ahaIcon && $store.state.slideActive.textColour === '#313131'"
          width="120"
          height="120"
          viewBox="0 0 30 30"
        />
        <aha-icon
          :name="slide.ahaIconWhite"
          :maintainColor="true"
          v-if="slide.ahaIconWhite && $store.state.slideActive.textColour === '#ffffff'"
          width="120"
          height="120"
          viewBox="0 0 30 30"
        />
      </div>

      <h2 class="heading-md-title content__text-heading">
        {{ slide.name }}
      </h2>
      <p class="text-center subheading-sm-title content__text-description">
        {{ slide.desc }}
      </p>
    </div>
    <div
      v-else
    >
      <div
        v-if="getPresenterLocale === 'fr'"
        class="content__bg bg-base-0"
        :style="{ 'background-image':
          'url(' + slide.previewUrlFr + ')'
        }"
      >
      </div>
      <div
        v-else
        class="content__bg bg-base-0"
        :style="{ 'background-image':
          'url(' + slide.previewUrl + ')'
        }"
      ></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import EventBus from '@/eventBus'

export default {
  props: {
    id: {
      type: String,
      required: false,
      default: '',
    },
    defaultSlide: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      slide: this.defaultSlide,
    }
  },
  computed: {
    ...mapGetters(['getPresenterLocale']),
  },
  mounted() {
    EventBus.$on('handleHoverOnSlideType', this.handleHoverOnSlideType)
  },
  destroyed() {
    EventBus.$off('handleHoverOnSlideType', this.handleHoverOnSlideType)
  },
  methods: {
    handleHoverOnSlideType(slide, mode, id) {
      if (this.id !== id) return
      if (mode === 'out') {
        this.slide = {}
        return
      }

      if (this.$store.state.slideTypePreview[slide.preview]) {
        slide.error = this.$store.state.slideTypePreview[slide.preview].error
      }
      this.slide = slide
    },
  },
}
</script>

<style lang="scss" scoped>
.canvas-preview__content {
  height: 110%;
  .content__text {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 1000; // To overlay QnA session w z-index: 999
    .content__text-heading {
      font-weight: bold;
      padding-bottom: 15px; // Padding of textSlide's heading
    }
    .content__text-description {
      width: 80%; // CSS of textSlides' subheading
      opacity: 0.85;
    }
    .content__text-icon {
      .content__text-icon-bullet {
        font-size: 3rem;
      }
    }
  }

  .content__bg  {
    @apply w-full h-full absolute top-0 left-0 z-30 rounded-md;
    @apply bg-cover bg-no-repeat bg-center;
  }
}
.has-icon-inside {
  .fa-comment {
    position: relative;

    &:after {
      content: "\F128";
      position: absolute;
      color: #fff;
      left: 31%;
      z-index: 1;
      font-size: 0.5em;
      top: 22%;
    }
  }
}
</style>
